<template>
  <div class="container">
    <content-header :data="[{text:'问题分类管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="分类名称">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改分类' : '添加分类'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import QuestionModel from 'models/question'

  export default {
    components: {
    },
    data () {
      return {
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          name: ''
        },
        formLabelWidth: '120px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        QuestionModel.findCategory(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            QuestionModel.deleteCategory({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        QuestionModel.createCategory(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          name: item.row.name
        }
        this.isObjShow = true
      },
      editHandle () {
        QuestionModel.updateCategory(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa

</style>



// WEBPACK FOOTER //
// src/views/QuestionCategory.vue